module.exports = __webpack_public_path__ + "static/img/5.8836bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/5.png
// module id = 9yEx
// module chunks = 0